<template>
  <div id="sitemap" class="header-padding bg-light-grey">
    <header class="page-header border-bottom ff ff-center horizontal-padding section-padding">
      <h1 style="margin-bottom: 0;">Sitemap</h1>
    </header>
    
    <section role="content" id="next-steps-content" class="horizontal-padding section-padding max-width">
      <div class="content-block ff ff-ttb ff-center">
        <div class="ff-12 ff-text-left">
          <h3 class="grey">Tests</h3>
          <hr class="hr-grey">
          <ul class="sitemap-list ff-columns">
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-3" :key="'testcat-soil'">
              <router-link to="/tests/soil">Soil</router-link>
              
              <ul class="sitemap-sublist ff">
                <li v-for="test in tests.soil" class="ff-12" :key="'test-'+test.index">
                  <router-link :to="test.url" v-html="test.name"></router-link>
                </li>
              </ul>
            </li>
            
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-3" :key="'testcat-plant'">
              <router-link to="/tests/plant">Plant</router-link>
              
              <ul class="sitemap-sublist ff">
                <li v-for="test in tests.plant" class="ff-12" :key="'test-'+test.index">
                  <router-link :to="test.url" v-html="test.name"></router-link>
                </li>
              </ul>
            </li>

            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-3" :key="'testcat-carbon'">
              <router-link to="/tests/carbon">Carbon (CFI)</router-link>
              
              <ul class="sitemap-sublist ff">
                <li v-for="test in tests.carbon" class="ff-12" :key="'test-'+test.index">
                  <router-link :to="test.url" v-html="test.name"></router-link>
                </li>
              </ul>
            </li>
            
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-3" :key="'testcat-water'">
              <router-link to="/tests/water">Water</router-link>
              
              <ul class="sitemap-sublist ff">
                <li v-for="test in tests.water" class="ff-12" :key="'test-'+test.index">
                  <router-link :to="test.url" v-html="test.name"></router-link>
                </li>
              </ul>
            </li>
            
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-3" :key="'testcat-other'">
              <router-link to="/tests/other">Other</router-link>
              
              <ul class="sitemap-sublist ff">
                <li v-for="test in tests.other" class="ff-12" :key="'test-'+test.index">
                  <router-link :to="test.url" v-html="test.name"></router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        
        <div class="ff-12">
          <h3 class="grey">Frequently Asked Questions</h3>
          <hr class="hr-grey">
          <ul class="sitemap-list ff-columns ff-text-left">
            <li v-for="(faqCat,f) in cats" class="ff-12 ff-sm-6 ff-md-4 ff-lg-3" :key="'faqcat-'+f">
              <router-link :to="'/faq/'+faqCat.slug">{{ faqCat.name }}</router-link>
              
              <ul class="sitemap-sublist ff">
                <li v-for="(faq,fq) in faqs[faqCat.slug]" class="ff-12" :key="'faqitem-'+fq">
                  <router-link :to="faq.url" v-html="faq.name"></router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        
        <div class="ff-12">
          <h3 class="grey">Miscellaneous</h3>
          <hr class="hr-grey">
          <ul class="sitemap-list ff-columns ff-text-left">
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-2">
              <router-link to="/">Home</router-link>
            </li>
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-2">
              <router-link to="/carbon">Carbon</router-link>
            </li>
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-2">
              <router-link to="/our-lab">Our Lab</router-link>
            </li>
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-2">
              <router-link to="/contact-us">Contact Us</router-link>
            </li>
            <li class="ff-12 ff-sm-6 ff-md-4 ff-lg-2">
              <router-link to="/search">Search</router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "Sitemap",
  data() {
    return {
      faqs: [],
      cats: []
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    tests() {
      let tests = {
        soil: [],
        plant: [],
        carbon: [],
        water: [],
        other: []
      };
      
      let storeTests = this.$store.getters.tests;
      
      if (storeTests.length > 0){
        let soil = storeTests.filter(t => t.sample_type_slug === 'soil' && t.list_visibility > 0);
        let plant = storeTests.filter(t => t.sample_type_slug === 'plant' && t.list_visibility > 0);
        let carbon = storeTests.filter(t => t.sample_type_slug === 'carbon' && t.list_visibility > 0);
        let water = storeTests.filter(t => t.sample_type_slug === 'water' && t.list_visibility > 0);
        let other = storeTests.filter(t => t.sample_type_slug === 'other' && t.list_visibility > 0);
        
        tests = {
          soil: soil,
          plant: plant,
          carbon: carbon,
          water: water,
          other: other
        };
      }
      
      return tests;
    },
    meta() {
      var meta = {
        title: "Sitemap",
        url: "https://www.csbplab.com.au/sitemap",
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    this.loadFAQCats();
    this.loadFAQ();
  },
  mounted() {
    
  },
  methods: {
    async loadFAQ() {
      
      // Request data from API
      await this.$axios.get(this.apiURL+"faq?grouped=true"). then((response) => {
        this.faqs = response.data.faq;
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the FAQ. Please reload page to try again.");
      });
      
    },
    async loadFAQCats() {
      // Request data from API
      await this.$axios.get(this.apiURL+"faq/categories"). then((response) => {
        this.cats = response.data.categories;
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the FAQ. Please reload page to try again.");
      });
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>